import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralpaymentRoutingModule } from './generalpayment-routing.module';
import { AdminModule } from '../admin/admin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { ParticularComponent } from './particular/particular.component';
import { CustomerComponent } from './customer/customer.component';
import { GeneralPaymentComponent } from './general-payment/general-payment.component';
import { GeneralPaymentCancelComponent } from './general-payment-cancel/general-payment-cancel.component';
import { GeneralPaymentReceiptPrintComponent } from './general-payment-receipt-print/general-payment-receipt-print.component';



@NgModule({
  declarations: [ParticularComponent,CustomerComponent,GeneralPaymentComponent,
    GeneralPaymentCancelComponent,
    GeneralPaymentReceiptPrintComponent],
  imports: [
    CommonModule,
    GeneralpaymentRoutingModule,
    AdminModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot()
  ]
})
export class GeneralpaymentModule { }
